import { getPagePath } from "@nanostores/router";
import { FC, ReactElement } from "react";

import { Entity, EntityClass } from "../api";
import BreadCrumbs from "../components/BreadCrumbs";
import { Heading } from "../components/catalyst/Heading";
import { EntityFormContent } from "../components/EntityFormContent";
import { $router } from "../stores/router";

interface EntityFormFullPageProps {
  entity?: Entity;
  entityClass: Pick<EntityClass, "id" | "name">;
}

const EntityFormFullPage: FC<EntityFormFullPageProps> = ({
  entity,
  entityClass,
}): ReactElement => {
  const isEditMode = !!entity;

  return (
    <div>
      <BreadCrumbs
        pages={[
          {
            href: getPagePath($router, "entityClassEdit", {
              classId: entityClass.id,
            }),
            name: entityClass.name,
          },
        ]}
      />
      <div className="mb-7 flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-4 dark:border-white/10">
        <Heading className="mr-auto" level={1}>
          {isEditMode ? "Edit Entity" : "Create Entity"}
        </Heading>
      </div>
      <EntityFormContent entity={entity} entityClass={entityClass} />
    </div>
  );
};

export default EntityFormFullPage;
